import React, { useEffect } from 'react';
import './dots.css';
export function Dots(props) {
    var pre = Array(props.arr.length).fill(0);
    var dots = pre.map(function (elem, index) {
        return React.createElement("div", { className: "dot", key: index + 'xzcvzxcv' });
    });
    useEffect(function () {
        return props.guessed.forEach(function (elem, index) {
            if (elem.guessedCorrect === true) {
                document
                    .getElementsByClassName('dot')[index].classList.add('greendot');
            }
            if (elem.guessedCorrect === false) {
                document.getElementsByClassName('dot')[index].classList.add('reddot');
            }
        });
    }, [dots, props.guessed]);
    return React.createElement("div", { className: "dotcontainer" }, dots);
}
